// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g4S_","content":"styles_content__2xikp"};